import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Modal, Form, Alert } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { TailSpin } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { getReports, sendMail } from "../../api/revenueService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { reportSchema } from "../../validations/authSchema";
import dummyUser from "../../assets/img/default.jpg";
const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function Reports({ type }) {
  const [searchText, setSearchText] = useState("");
  const [reports, setReports] = useState([]);
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [error, setError] = useState("");
  const handleShow = () => setShow(true);
  const senttoggle = () => setSent(!sent);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reportSchema),
  });

  useEffect(() => {
    fetchReports();
  }, [type]);

  const fetchReports = async () => {
    setLoading(true);
    const response = await getReports(type);

    if (response.data) {
      setReports(response.data);
    }
    setLoading(false);
  };

  const handleSendMessage = async (data) => {
    try {
      data.email = email;
      data.reportId = selectedReportId;
      const response = await sendMail(data);
      if (response.code === 200) {
        toast.success(response.message);
        setSent(false);
        setEmail("");
        setSubject("");
        setContent("");
        fetchReports();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleOpenSendMessage = (row) => {
    setEmail(row.email);
    setSelectedReportId(row._id);
    setSent(true);
  };

  // ✅ dynamic columns
  const getColumns = () => {
    const base = [
      {
        name: "S.No.",
        width: "70px",
        cell: (row, index) => index + 1,
      },
      {
        name: "Reporter",
        width: "140px",
        selector: (row) => row.reportFrom,
        sortable: true,
        cell: (row) => (
          <Link
            to={`/admin/view-user/${row.reporterId}?tab=basicinfo`}
            className="text-primary"
          >
            {row.reportFrom}
          </Link>
        ),
      },
      {
        name: "Reason",
        width: "300px",
        selector: (row) => row.reasonName,
        sortable: true,
        cell: (row) => row.reasonName,
      },
      {
        name: "Description",
        width: "240px",
        selector: (row) => row.description,
        sortable: true,
        cell: (row) => row.description,
      },
      {
        name: "Date Reported",
        width: "160px",
        selector: (row) => new Date(row.createdAt).toLocaleDateString(),
        sortable: true,
        cell: (row) => new Date(row.createdAt).toLocaleDateString(),
      },
    ];

    if (type === "tales") {
      return [
        base[0],
        base[1],
        {
          name: "Tale",
          width: "150px",
          selector: (row) => row.tale,
          sortable: true,
          cell: (row) => row.tale || "N/A",
        },
        {
          name: "Tale Author",
          width: "150px",
          selector: (row) => row.taleAuthor,
          sortable: true,
          cell: (row) => row.taleAuthor || "N/A",
        },
        base[2],
        base[3],
        {
          name: "Image",
          width: "100px",
          selector: (row) => row.taleImage,
          sortable: true,
          cell: (row) => (
            <img
              className="table_img rounded-circle img-thumbnail me-2"
              src={row.taleImage ? `${MEDIA_URL}/${row.taleImage}` : dummyUser}
              alt=""
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = dummyUser;
              }}
            />
          ),
        },
        base[4],
      ];
    }

    if (type === "user") {
      return base; // Reporter, Reason, Description, Date
    }

    return base; // default
  };

  const columns = getColumns();

  // Filter data based on search text
  const filteredData = reports.filter((item) => {
    const searchTerm = searchText.toLowerCase();
    return (
      item?.reportFrom?.toLowerCase().includes(searchTerm) ||
      item?.reasonName?.toLowerCase().includes(searchTerm) ||
      item?.description?.toLowerCase().includes(searchTerm)
    );
  });

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>{type.charAt(0).toUpperCase() + type.slice(1)} Reports</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? (
                <div className="text-center py-5">
                  <div
                    className="text-center py-5"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                      width: "100%",
                    }}
                  >
                    <TailSpin height={50} width={80} color="#4fa94d" />
                  </div>
                </div>
              ) : error ? (
                <Alert variant="danger" className="text-center">
                  {error}
                </Alert>
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  progressPending={loading}
                  className="custom-table"
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={sent} onHide={senttoggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Send Message</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(handleSendMessage)}>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter subject"
                {...register("subject")}
              />
              {errors.subject && (
                <p className="text-danger">{errors.subject.message}</p>
              )}
            </Form.Group>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter message"
                {...register("content")}
              />
              {errors.content && (
                <p className="text-danger">{errors.content.message}</p>
              )}
            </Form.Group>
            <Button
              onClick={senttoggle}
              className="btn btn-secondary px-4 min_width110"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="btn btn-primary px-4 mx-2 min_width110"
            >
              Send
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
